import { SerializedStyles, css } from "@emotion/react";
import { ellipsis } from "polished";

import { DesignToken, ShadowToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const tagListContainerStyles = (isVisible = true): SerializedStyles => css`
  display: ${isVisible ? "block" : "none"};
  border-radius: 4px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

export const dropdownListStyles = (isVisible = true): SerializedStyles => css`
  border-radius: 4px;
  max-height: 352px;
  display: ${isVisible ? "block" : "none"};

  .lc-dropdown__list-item {
    padding: 0;
  }

  .lc-dropdown__list-item__content {
    max-width: 360px;
    width: 100%;
  }

  .lc-dropdown__list-item__title {
    white-space: initial;
  }
`;

export const itemContentWrapper = css`
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  line-height: 22px;
  max-width: 360px;
  min-width: 90px;
  padding: 0 10px;

  &.focused {
    background-color: ${withVar(DesignToken.SurfaceTertiaryHover)};
  }
`;

export const tagResponsesCount = css`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  width: 16px;
  text-align: end;
`;

export const itemName = css`
  white-space: pre-wrap;
`;

export const tagName = css`
  ${itemName}
  ${ellipsis()}
  width: 100%;
  padding: 0 10px;
`;

const itemArrow = css`
  position: relative;
  top: 7px;
`;

export const responseArrow = css`
  ${itemArrow}
  transform: rotate(180deg);
`;

export const tagArrow = css`
  ${itemArrow}
  margin-left: auto;
`;

export const responseArrowWrapper = css`
  padding-right: 10px;
  height: 22px;
`;

export const loaderContainerStyles = css`
  align-items: center;
  box-shadow: ${withVar(ShadowToken.PopOver)};
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 22px;
  padding: 0 10px;
`;

export const circleLoaderContainerStyles = css`
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 5px;
`;

export const circleLoaderStyles = css`
  position: relative;
  border-width: 2px;
  border-color: ${withVar(DesignToken.ActionPrimaryDisabled)};
  border-top-color: ${withVar(DesignToken.ActionPrimaryDefault)};
  transition: all 0.2s ease-in-out;
`;
